import { Select } from "antd/es";

export const MultiSelectItem = Select.Option;
